<template>
  <v-ons-page>

    <v-ons-toolbar>
      <div class="left">
        <v-ons-back-button v-if="! $md"></v-ons-back-button>
        <v-ons-toolbar-button v-else @click="pageStack.pop()">
          <v-ons-icon icon="md-arrow-left" size="24px"></v-ons-icon>
        </v-ons-toolbar-button>
      </div>
      <div class="center">
        Tonnes {{ type == 'apport' ? 'produites' : 'à vendre' }}
      </div>
    </v-ons-toolbar>

    <div class="content">

      <app-error-msg :list="errorMsgList"></app-error-msg>

      <v-ons-list modifier="noborder perflist">

        <app-label input-id="inputSurf" label="Surface (ha)" :error-msg-list="errorMsgList"></app-label>
        <app-input input-id="inputSurf" ref="inputSurf" input-type="number" v-model.number="culture.surface"
                   placeholder="Entrez la surface en ha" input-step="0.01"></app-input>

        <app-label input-id="inputRdt" :label="labelRdt" :error-msg-list="errorMsgList"></app-label>
        <app-input input-id="inputRdt" ref="inputRdt" input-type="number" v-model.number="culture.rendement"
                   placeholder="Entrez le rendement en q/ha" input-step="0.1"></app-input>

      </v-ons-list>

      <v-ons-list modifier="noborder">

        <v-ons-list-item v-if="type == 'apport'" modifier="perfcol">
          <ons-row>
            <ons-col>
              <p>
                Tonnes produites
              </p>
              <h3>
                {{ tonneProd !== '' ? tonneProd.toLocaleString('fr') : '__' }} t
              </h3>
            </ons-col>
          </ons-row>
        </v-ons-list-item>

        <v-ons-list-item v-else modifier="perfcol" @click="isShowAlertTonne = true">
          <ons-row>
            <ons-col>
              <p>
                Tonnes à vendre
                &nbsp;<v-ons-icon icon="fa-pencil-alt"></v-ons-icon>
              </p>
              <h3>
                {{ (strategie.tonne !== '' ? strategie.tonne : (tonneProd !== '' ? tonneProd : '__')).toLocaleString('fr') }} t
              </h3>
            </ons-col>
          </ons-row>
        </v-ons-list-item>

      </v-ons-list>

      <footer class="footer--perfbutton">
        <v-ons-button modifier="large--cta perflarge" @click="saveTonne">
          Enregistrer
          <v-ons-progress-circular v-if="isSubmit" :modifier="$mdModifier" indeterminate></v-ons-progress-circular>
        </v-ons-button>
      </footer>

    </div>

    <v-ons-alert-dialog :modifier="$mdModifier + ' perfbadge rowfooter'" :visible.sync="isShowAlertTonne"
                        cancelable ref="alertTonne" @postshow="setFocusTonne">
      <template slot="title">
        Tonnes à vendre
      </template>
      {{ tonneProd !== '' ?
        'Renseignez une valeur si vous ne vendez pas exactement ce que vous avez produit.' :
        'Renseignez directement une valeur sans indiquer la surface et le rendement.'
      }}
      <v-ons-list modifier="noborder nopadding transparent">
        <app-input input-type="number" v-model.number="strategie.tonne"
                   placeholder="Entrez une quantité" input-step="0.001"></app-input>
      </v-ons-list>
      <template slot="footer">
        <v-ons-alert-dialog-button @click="isShowAlertTonne = false">Fermer</v-ons-alert-dialog-button>
      </template>
    </v-ons-alert-dialog>

  </v-ons-page>
</template>

<script>
import mixinsCommons from '../mixins/commons.js';
import mixinsCours from '../mixins/cours.js';

import { store } from '../store.js';

import AppErrorMsg from '../partials/ErrorMsg.vue';
import AppLabel from '../partials/Label.vue';
import AppInput from '../partials/Input.vue';

export default {
  mixins: [mixinsCommons, mixinsCours],
  components: { AppErrorMsg, AppLabel, AppInput },
  props: ['pageStack'],
  data() {
    return {
      refCulture: '',
      refDestination: '',
      client: '',
      culture: {
        surface: '',
        rendement: '',
        isSurfRdt: false,
      },
      strategie: {
        tonne: ''
      },
      isShowAlertTonne: false,
      type: "vente",
      state: store.state,
      data: store.data
    };
  },
  computed: {
    user() {
      return this.state.user;
    },
    campagne() {
      return this.user.campagne;
    },
    clientConnect() {
      return this.state.client;
    },
    referentiel() {
      return this.data.referentiel;
    },
    labelRdt() {
      var label = 'Rendement';
      var date = new Date();
      if (date.getFullYear() < this.campagne || // si prochaine campagne
        // si recolte après le mois prochain
        (date.getFullYear() == this.campagne && date.getMonth() + 1 < this.referentiel.cultures[this.refCulture].recolte - 1)) {
        label += ' prévisionnel';
      }
      return label + ' (q/ha)'
    },
    tonneProd() {
      return this.getTonneProd(this.culture, true);
    }
  },
  methods: {
    setFocusTonne() {
      this.showKeyboard();
      this.$setAutoFocus(this.$refs.alertTonne.$el, 'ons-input');
    },
    async saveTonne() {
      if(this.isSubmit){
        return;
      }
      this.resetErrorMsgList();

      if(! this.client){
        if((this.culture.surface === '' && (this.culture.isSurfRdt || this.culture.rendement !== '')) || this.culture.surface === 0) {
          this.setErrorMsgList('inputSurf', "La surface est obligatoire");
        }
        if(this.culture.rendement === '' && (this.culture.isSurfRdt || this.culture.surface !== '')) {
          this.setErrorMsgList('inputRdt', "Le rendement est obligatoire");
        }
      }

      if(Object.keys(this.errorMsgList).length) {
        this.$scrollTop();
        return;
      }

      this.isSubmit = true;

      const body = {
        id: this.user.id,
        date: this.user.date,
        ref_culture: this.refCulture,
        ref_destination: this.refDestination,
        data: {
          tonne: this.strategie.tonne,
        }
      };

      if(this.culture.surface !== '' || this.culture.isSurfRdt){
        body.data.surface = this.culture.surface;
      }
      if(this.culture.rendement !== '' || this.culture.isSurfRdt){
        if(this.culture.rendement === ''){
          body.data.rendement = '';
        } else {
          body.data.rendement = this.culture.rendement ? Math.round(this.culture.rendement / 10 *100000)/100000 : 0.00001;
        }
      }
      if(! this.client && this.culture.surface){
        for (let i = 0; i < store.state.user.cultures.length; i++) {
          const cult = store.state.user.cultures[i];
          if (cult.ref_culture == this.refCulture && cult.ref_destination == this.refDestination) {
            cult.surface = body.data.surface;
            cult.rendement = body.data.rendement;
          }
        }
      }

      if(this.client){
        body.client = this.client;
        if(! store.state.user.ventes[this.refCulture][this.refDestination].clients){
          this.$set(store.state.user.ventes[this.refCulture][this.refDestination], 'clients', {});
        }
        if(! store.state.user.ventes[this.refCulture][this.refDestination].clients[this.client]){
          this.$set(store.state.user.ventes[this.refCulture][this.refDestination].clients, this.client, {});
        }
        for (const key in body.data) {
          this.$set(store.state.user.ventes[this.refCulture][this.refDestination].clients[this.client], key, body.data[key]);
        }
      } else {
        this.$set(store.state.user.ventes[this.refCulture][this.refDestination], 'tonne', body.data.tonne);
      }

      this.ionicStorage.set('user', this.user);

      this.$emit('call-api', {
        call: {
          path: this.getPath(this.client ? '/tc/tonne' : '/tonne'),
          data: body
        }
      });

      if(this.client && ! this.clientConnect.id){
        this.pageStack.length > 2 && this.pageStack.splice(this.pageStack.length - 2, 2);
      } else {
        this.pageStack.length > 1 && this.pageStack.pop();
      }
    }
  },
  created() {
    if(this.client){
      const clientConnectInfos = this.getClientConnectInfos(this.client, this.user.ventes, this.refCulture, this.refDestination);
      this.setJson(this.culture, clientConnectInfos);
      if(this.culture.surface !== ''){
        this.culture.isSurfRdt = true;
      }
      if(this.culture.rendement !== ''){
        this.culture.isSurfRdt = true;
        if(this.culture.rendement < 0.0001) {
          this.culture.rendement = 0;
        } else {
          this.culture.rendement = Math.round(this.culture.rendement*100000)/100000 * 10;
        }
      }
      this.setJson(this.strategie, clientConnectInfos);
    } else {
      const cult = this.getCultureFromList(this.user.cultures, this.refCulture, this.refDestination);
      if(cult){
        if (cult.surface === '') {
          // RAF
        } else {
          this.culture.isSurfRdt = true;
          this.culture.surface = cult.surface;
          if (cult.rendement < 0.0001) {
            this.culture.rendement = 0;
          } else {
            this.culture.rendement = Math.round(cult.rendement*100000)/100000 * 10;
          }
        }
      }
      this.setJson(this.strategie, this.user.ventes[this.refCulture][this.refDestination]);
    }
  }
}
</script>

<style>
.list-item--perfcol__center p {
  font-size: 17px;
}
.list-item--perfcol__center h3 {
  font-size: 19px;
}
</style>